const greys = {
    100: '#FAFAFA',
    200: '#F5F5F5',
    300: '#EFEFF0',
    400: '#E4E5E7',
    500: '#DADBDD',
    600: '#C5C6C9',
    700: '#B5B6BA',
    800: '#95979D',
    900: '#7A7D85',
    1000: '#62646A',
    1050: '#515357',
    1100: '#404145',
    1150: '#2A2B2E',
    1200: '#1C1D1F',
    1250: '#0E0E0F',
} as const;

const surfaces = {
    one: 'rgba(98, 100, 106, 0.4)',
    two: 'rgba(98, 100, 106, 0.25)',
    three: 'rgba(98, 100, 106, 0.2)',
    four: 'rgba(98, 100, 106, 0.1)',
    five: 'rgba(117, 148, 233, 0.2)',
} as const;

const colors = {
    grey100: greys[100],
    grey200: greys[200],
    grey300: greys[300],
    grey400: greys[400],
    grey500: greys[500],
    grey600: greys[600],
    grey700: greys[700],
    grey800: greys[800],
    grey900: greys[900],
    grey1000: greys[1000],
    grey1050: greys[1050],
    grey1100: greys[1100],
    grey1150: greys[1150],
    grey1200: greys[1200],
    grey1250: greys[1250],
    alphaGrey125: '#0C0C0D',
    alphaGrey125_60: '#0C0C0D99',
    alphaGrey125_70: '#0C0C0DB2',
    alphaGrey125_80: '#0C0C0DCC',
    black: '#000000',
    white: '#FFFFFF',
    alphaWhite25: 'rgba(255, 255, 255, 0.25)',
    backgroundPrimary: greys[1250],
    scrollbarColorOnDark: surfaces.one,
    textOnDark: greys[300],
    textOnLight: greys[1250],
    textSecondary: greys[700],
    surfaceOne: surfaces.one,
    surfaceTwo: surfaces.two,
    surfaceThree: surfaces.three,
    surfaceFour: surfaces.four,
    surfaceFive: surfaces.five,
    modalBorder: 'rgba(177, 177, 177, 0.3)',
    buttonBorder: 'rgba(255, 255, 255, 0.24)',
    background_1_primary: '#FFE2C9',
    background_1_secondary: '#FFC796',
    background_2_primary: '#FFD8E2',
    background_2_secondary: '#FFADC1',
    accent_2: '#E15579',
    background_3_primary: '#B3CAEF',
    background_3_secondary: '#80A3DB',
    background_4_primary: '#FFCFA4',
    background_4_secondary: '#EE9B53',
    accent_4: '#B95600',
    background_5_primary: '#A8C0FF',
    background_5_secondary: '#8597FF',
    background_6_primary: '#FFC3BF',
    background_6_secondary: '#FF948C',
    accent_6: '#EF766B',
    error_stroke: '#F74040',
    error_background: '#F740402B',
    error_text: '#FFDCDE',
} as const;

export const theme = {
    colors,
} as const;
